// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__qqs0H","text":"style_text__pbFDy","wheelBox":"style_wheelBox__1-zkQ","wheel":"style_wheel__9rN6q","pointer":"style_pointer__Fv6eW"};